import { trackingUtils } from '@debijenkorf/dbk-common';

import { Product } from '@/types/api/product';

export interface ViewItemList {
  products: (Product & { listIndex: number })[];
  location: string;
  listId?: string;
  listName?: string;
}

export const viewItemList = ({ products, location, listId, listName }: ViewItemList) => ({
  event: 'view_item_list',
  unique_event_id: trackingUtils.generateRandomUUID(),
  ecommerce_ga4: {
    currency: 'EUR',
    items: products.map((product: any) => ({
      ...trackingUtils.getGA4ProductModel({
        product,
        location,
        itemListId: listId,
        itemListName: trackingUtils.getItemListName({ product, listName }),
        index: product.listIndex + 1,
        isListEvent: true,
      }),
    })),
  },
});
